module.exports = __webpack_public_path__ + "img/upsort.00ca91ba.svg";